var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { closable: _vm.clos, "mask-closable": false, width: "488" },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "p",
        { staticClass: "modalHead", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v(_vm._s(_vm.modalheader))])]
      ),
      _c("div", { staticClass: "modalContent" }, [
        _c("p", [_vm._v(_vm._s(_vm.modalcontent))]),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              attrs: { type: "ghost", size: "spec" },
              on: { click: _vm.cancle },
            },
            [_vm._v(" " + _vm._s(_vm.$t("webList.addWebDialog.cancel")))]
          ),
          _c(
            "pp-button",
            {
              attrs: { type: "primary", size: "spec", loading: _vm.loading2 },
              on: { click: _vm.confirm },
            },
            [_vm._v(_vm._s(_vm.$t("webList.tradeDetail.cancelPayment")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }